export default {
  viewAllResources: 'Voir toutes les ressources',
  clearCategoriesFilters: 'Effacer tous les filtres de catégorie',
  loading: 'Chargement des données...',
  errorLoading: 'Erreur lors du chargement des données',
  tryAgain: 'Réessayer',
  noDataFound: 'Aucune donnée trouvée',
  tryAdjustingFilters: 'Essayez d\'ajuster votre recherche ou vos filtres.',
};
